import { Outlet } from 'react-router-dom';

// project-imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import { ForceThemeMode } from 'contexts/ThemeScopeContext';
import { ThemeMode } from 'config';

// ==============================|| LAYOUT - AUTH ||============================== //

export default function AuthLayout() {
  return (
    <>
      <ForceThemeMode mode={ThemeMode.LIGHT} />
      <GuestGuard>
        <Outlet />
      </GuestGuard>
    </>
  );
}
